module.exports = __webpack_public_path__ + "img/app-steps.1b13ac92.svg";